/* global dataLayer, gtag, posabitAnalyticsProvider */
import TagManager from 'react-gtm-module';

const initializeGTM = (analyticsRef) => {
    const tagManagerArgs = {
        gtmId: analyticsRef
    };
    TagManager.initialize(tagManagerArgs);
};

// always load POSaBIT's GA4 (Ecomm Menu: ecomm-menu.posabit.com (a non existent sub domain))
// optionally load the merchant's GA4
const initializeGA4 = (analyticsRef, analyticsProvider) => {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=G-QE56TJRYNB`;
    script.async = true;
    document.head.appendChild(script);
    script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            dataLayer.push(arguments);
        };
        gtag('js', new Date());
        gtag('config', 'G-QE56TJRYNB');
        if (analyticsProvider === 'google_analytics') {
            gtag('config', analyticsRef);
        }
    };
};

const AnalyticsProvider = (trackingProvider, trackingId) => {
    window.posabitAnalyticsProvider = trackingProvider;
    initializeGA4(trackingId, trackingProvider);
    if (trackingProvider === 'google_tag_manager') {
        initializeGTM(trackingId);
    }
};

export default AnalyticsProvider;

export function trackViewItem(variant) {
    setTimeout(() => {
        const value = (variant?.price_cents / 100).toFixed(2);
        const items = [{
            item_id: variant?.sku_id,
            item_name: variant?.name,
            price: (variant?.price_cents / 100).toFixed(2),
            quantity: 1
        }];

        // this will fire event for POSaBIT GA4 and (Merchant GA4 or Merchant GTM)
        gtag('event', 'view_item', {
            currency: 'USD',
            value: value,
            items: items
        });

        // seems like this isn't needed for GTM, GTM detects GA4 gtag event, so this causes double firing
        // if (window.posabitAnalyticsProvider === 'google_tag_manager') {
        //     window.dataLayer = window.dataLayer || [];
        //     window.dataLayer.push({
        //         event: 'view_item',
        //         ecommerce: {
        //             currency: 'USD',
        //             value: value,
        //             items: items
        //         }
        //     });
        // }
    }, 0);
}

export function trackAddToCart(variant) {
    setTimeout(() => {
        const value = (variant?.price_cents / 100).toFixed(2);
        const items = [{
            item_id: variant?.sku_id,
            item_name: variant?.name,
            price: (variant?.price_cents / 100).toFixed(2),
            quantity: variant?.quantity
        }];

        gtag('event', 'add_to_cart', {
            currency: 'USD',
            value: value,
            items: items
        });

        // if (window.posabitAnalyticsProvider === 'google_tag_manager') {
        //     window.dataLayer = window.dataLayer || [];
        //     window.dataLayer.push({
        //         event: 'add_to_cart',
        //         ecommerce: {
        //             currency: 'USD',
        //             value: value,
        //             items: items
        //         }
        //     });
        // }
    }, 0);
}

export function trackRemoveFromCart(variant) {
    setTimeout(() => {
        const value = (variant?.price_cents / 100).toFixed(2);
        const items = [{
            item_id: variant?.sku_id,
            item_name: variant?.name,
            price: (variant?.price / 100).toFixed(2),
            quantity: variant.quantity
        }];

        gtag('event', 'remove_from_cart', {
            currency: 'USD',
            value: value,
            items: items
        });

        // if (window.posabitAnalyticsProvider === 'google_tag_manager') {
        //     window.dataLayer = window.dataLayer || [];
        //     window.dataLayer.push({
        //         event: 'remove_from_cart',
        //         ecommerce: {
        //             currency: 'USD',
        //             value: value,
        //             items: items
        //         }
        //     });
        // }
    }, 0);
}

export function trackBeginCheckout(quote) {
    setTimeout(() => {
        const value = (quote?.totals?.total / 100).toFixed(2);
        const items = quote?.items.map(item => ({
            item_id: item.sku_id,
            item_name: item.name,
            price: (item.price / 100).toFixed(2),
            quantity: item.quantity
        }));

        gtag('event', 'begin_checkout', {
            currency: 'USD',
            value,
            items
        });

        // if (window.posabitAnalyticsProvider === 'google_tag_manager') {
        //     window.dataLayer = window.dataLayer || [];
        //     window.dataLayer.push({
        //         event: 'begin_checkout',
        //         ecommerce: {
        //             currency: 'USD',
        //             value,
        //             items
        //         }
        //     });
        // }
    }, 0);
}

// this is only event i haven't been able to test personally
export function trackPurchase(quote) {
    setTimeout(() => {
        const value = (quote?.totals?.total / 100).toFixed(2);
        const tax   = (quote?.totals?.tax / 100).toFixed(2);
        const items = quote?.items.map(item => ({
            item_id: item.sku_id,
            item_name: item.name,
            price: (item.price / 100).toFixed(2),
            quantity: item.quantity
        }));

        gtag('event', 'purchase', {
            currency:       'USD',
            transaction_id: quote?.reference_no,
            tax:            tax,
            shipping:       0.0,
            value,
            items
        });

        // if (window.posabitAnalyticsProvider === 'google_tag_manager') {
        //     window.dataLayer = window.dataLayer || [];
        //     window.dataLayer.push({
        //         event: 'purchase',
        //         ecommerce: {
        //             currency: 'USD',
        //             transaction_id: quote?.reference_no,
        //             tax:            tax,
        //             shipping:       0.0,
        //             value,
        //             items
        //         }
        //     });
        // }
    }, 0);
}

// Google Tag Manager (GTM) Setup
// create a container
// create GA4 tag, tag type: Google Tag, triggering: Initialization - All Pages
// create Custom event for all events trigger, trigger type: Custom Event, event name: .* (use regex matching),
//   fires on: All Custom Events
// create GA4 events tag, tag type: Google Analytics: GA4 Event, triggering: Custom event for all events,
//   measurement id: is GA4 measurement id, event name: {{Event}}, ecommerce: Send Ecommerce Data, datasource: Data Layer
// publish the container
